/* eslint-disable react/no-array-index-key */
import React from 'react';
import classes from './Stepper.scss';

interface IStepper {
  stepHeaders: { stepId: number; header: string }[];
  stepId: number;
}

const Stepper: React.FC<IStepper> = ({ stepHeaders, stepId }) => (
  <ul className={classes.stepper}>
    {stepHeaders.map((step, index) => (
      <li key={index} className={classes.step}>
        <div className={`${classes.circle} ${step.stepId <= stepId ? classes.active : ''}`} />
        {index < stepHeaders.length - 1 && <div className={`${classes.line} ${step.stepId < stepId ? classes.active : ''}`} />}
        <span className={`${classes.label} ${step.stepId <= stepId ? classes.active : ''}`}>{step.header}</span>
      </li>
    ))}
  </ul>
);

export default Stepper;
